<template>
  <div id="my-projects-page" class="p-3" @click="closeAllMenus()">
    <!-- Edit Showroom Modal -->
    <EditProject
      v-if="editMode"
      :project="projectToBeEdited"
      :projectTypeToBeEdited="projectTypeToBeEdited"
      :customers="customers"
      v-on="{ editEvent, updateProjectData }"
    />
    <main>
      <!-- Filters -->

      <!-- ## FILTERS ## -->
      <section
        class="header-container row align-center no-gutters"
        v-if="!loading"
      >
        <!-- Type of Projects -->
        <h1
          class="forza-bold text-uppercase col-xs-12 col-sm-12 col-md-12 col-lg-3 mb-mobile-4"
        >
          My {{ typesOfProjectsToShow }}s
        </h1>
        <!-- By Title -->
        <div
          class="flex col-xs-12 col-sm-12 col-md-12 col-lg-4 mb-mobile-4 input-container"
          id="search-by-name-container"
        >
          <input
            type="text"
            class="form-control mr-3"
            placeholder="Search by Catalog Name and hit enter"
            id="team-link-search"
            v-model="filters.search"
            @change="triggerSearch"
          />
          <button class="btn" @click="triggerSearch">
            <img src="@/assets/icons/ui/search-outline.svg" alt="" /> Search
          </button>
        </div>

        <a class="btn" :href="fsgSiteCreateProjectUrl" target="_blank">
          <img
            src="@/assets/icons/ui/add-circle-outline-black.svg"
            alt="add icon"
          />
          Create new {{ typesOfProjectsToShow }}
        </a>

        <!-- By Rep -->
        <!-- <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 mb-mobile-4">
              <div
                class="
                  flex
                  row
                  align-items-center
                  justify-content-around
                  no-gutters
                "
              >
                <label class="col-lg-4 text-lg-center" for="tl-"
                  >Filter by Rep</label
                >
                <select
                  class="form-control col-lg-8"
                  v-model="filters.rep_id"
                  @change="getProjects(true)"
                >
                  <option value="0">All reps</option>
                  <option
                    v-for="rep in dealer.reps"
                    :key="rep.id + '-rep'"
                    :value="Number(rep.id)"
                  >
                    {{ rep.name }}
                  </option>
                </select>
              </div>
            </div> -->

        <!-- BY TYPE -->
        <!-- <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 mb-mobile-4">
              <div
                class="
                  flex
                  row
                  align-items-center
                  justify-content-around
                  no-gutters
                "
              >
                <label class="col-lg-4 text-lg-center" for="tl-"
                  >Filter by project type</label
                >
                <select
                  class="form-control col-lg-8"
                  v-model="filters.filteredTypeOfProject"
                  @change="getProjects(true)"
                >
                  <option disabled>Select a type</option>
                  <option
                    v-for="type in typesOfProjects"
                    :key="type + -'type'"
                    :value="type"
                  >
                    {{ type }}
                  </option>
                </select>
              </div>
            </div> -->
      </section>

      <!-- Projects List-->
      <section v-if="!loading" class="projects-container">
        <!-- Show All Projects -->
        <ul class="table-header">
          <li class="table-column title">Catalog Name</li>
          <li class="table-column date">Created Date</li>
          <!-- Reps Filter -->
          <li class="table-column rep">
            <p>Sales Rep</p>
            <button
              class="btn"
              @click.stop="
                showRepsFilter = !showRepsFilter;
                showStatusFilter = false;
              "
            >
              <img
                src="@/assets/icons/ui/filter.png"
                alt="filter by rep icon"
              />
            </button>

            <div class="filter-container" :class="{ active: showRepsFilter }">
              <label for="any-rep">
                <input
                  type="checkbox"
                  id="any-rep"
                  name="any-rep"
                  v-model="filterByAllReps"
                  :disabled="filterByAllReps"
                />
                <span>Any</span>
              </label>
              <label
                v-for="rep in dealer.reps"
                :for="rep.id + '-rep'"
                :key="rep.id + '-rep'"
              >
                <input
                  type="checkbox"
                  :id="rep.id + '-rep'"
                  :name="rep.id + '-rep'"
                  :key="rep.id + '-rep'"
                  :value="Number(rep.id)"
                  @input="handleRepFilter(rep)"
                  :checked="repsToFilter.includes(Number(rep.id))"
                />
                <span>{{ rep.name }}</span>
              </label>
            </div>
          </li>
          <li class="table-column rep">
            <p>Status</p>
            <button
              class="btn"
              @click.stop="
                showStatusFilter = !showStatusFilter;
                showRepsFilter = false;
              "
            >
              <img
                src="@/assets/icons/ui/filter.png"
                alt="filter by rep icon"
              />
            </button>

            <div class="filter-container" :class="{ active: showStatusFilter }">
              <label
                v-for="status in statusList"
                :for="status + '-status'"
                :key="status + '-status'"
              >
                <input
                  type="checkbox"
                  :id="status + '-status'"
                  :name="status + '-status'"
                  :key="status + '-status'"
                  :value="status"
                  @input="handleStatusFilter(status)"
                  :checked="statusToFilter.includes(status)"
                />
                <span>{{ status }}</span>
              </label>
            </div>
          </li>
          <!-- <li class="table-column status">Status</li> -->
        </ul>

        <ul class="table-content-container">
          <MyProjectsListCard
            v-for="project in sortedProjects"
            :key="project.id + '-project-' + project.project_type"
            :project="project"
            :typeOfProject="typesOfProjectsToShow"
            :openedMenu="openedMenu"
            @changeProjectStatus="
              (status) => updateProjectData({ ...project, status })
            "
            @archiveProject="
              () => updateProjectData({ ...project, deleted_at: true })
            "
            @restoreProject="
              () => updateProjectData({ ...project, deleted_at: null })
            "
            @openMenu="(id) => handleSetOpenedMenu(id)"
          />
        </ul>

        <section class="team-links-container row">
          <!-- No projects found by filters -->
          <article v-if="!projects.length" class="team-link col text-center">
            <h3>No Projects Found</h3>
          </article>
        </section>
      </section>

      <MyProjectsPagination
        v-if="!loading"
        :totalPages="totalPages"
        :selectedPage="page"
        :totalItems="totalItems"
        :sortedBy="sortedBy"
        :sortedByOptions="sortedByOptions"
        :showArchivedProjects="showArchivedProjects"
        v-on="{
          'on-set-page': setPage,
          'on-sort-by': setSortedBy,
          'on-toggle-checkbox': toggleShowArchiveProjects,
        }"
        :showCheckboxForArchiveProjects="true"
      />

      <!-- Loader -->
      <div class="loading-spinner" v-if="loading">
        <div class="flex flex-center">
          <div class="kt-spinner kt-spinner--md kt-spinner--info"></div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { debounce } from "lodash";
import axios from "axios";
import { mapState, mapGetters, mapActions } from "vuex";
import EditProject from "@/components/Dashboard/MyProjects/EditProject.vue";

import MyProjectsListCard from "@/components/Dashboard/MyProjects/MyProjectsListCard.vue";
import MyProjectsPagination from "@/components/Dashboard/MyProjects/MyProjectsPagination.vue";
import CONSTANTS from "@/constants.js";
export default {
  name: "MyProjects",
  components: {
    EditProject,
    MyProjectsPagination,
    MyProjectsListCard,
  },
  data() {
    return {
      customers: [],
      projects: [],
      page: 1,
      totalPages: 1,
      totalItems: 1,
      editMode: false,
      loading: false,
      typesOfProjects: ["All", "Showrooms", "Catalogs", "Snapsheets"],
      typesOfProjectsToShow: "",
      filters: {
        search: "",
        rep_id: 0,
        filteredTypeOfProject: "All",
      },
      openedMenu: null,
      showArchivedProjects: true,
      showRepsFilter: false,
      showStatusFilter: false,
      repsToFilter: [],
      statusToFilter: [],
      sortedBy: "newer",
      sortedByOptions: [
        { label: "Date Created (Newer)", value: "newer" },
        { label: "Date Created (Oldest)", value: "oldest" },
        { label: "Project Name (A to Z)", value: "a-to-z" },
        { label: "Project Name (Z to A)", value: "z-to-a" },
      ],
      statusList: [
        CONSTANTS.PROJECT_STATUS.ARCHIVED,
        CONSTANTS.PROJECT_STATUS.COMPLETE,
        CONSTANTS.PROJECT_STATUS.DRAFT,
        CONSTANTS.PROJECT_STATUS.PUBLISHED,
        CONSTANTS.PROJECT_STATUS.OPEN_LOCKER,
        CONSTANTS.PROJECT_STATUS.QUOTE_STATUS,
      ],
      //This will be the project to pass to the modal
      projectToBeEdited: {},
      projectTypeToBeEdited: "",
      helpText:
        "All projects you create will be saved here for you to access at any time. You can search based on the project name, or filter by Rep and/or Project Type to keep track of where everything stands. If you want to hide any projects from this page - please click on Quick Actions (•••) and Archive it.",
    };
  },
  computed: {
    ...mapState(["auth", "dealer", "settings"]),
    ...mapGetters("project", [
      "fsgSiteCreatePlaybookUrl",
      "fsgSiteCreateSnapsheetUrl",
      "isSnapsheet",
    ]),

    ...mapGetters("project", [
      "fsgSiteCreatePlaybookUrl",
      "fsgSiteCreateSnapsheetUrl",
      "isSnapsheet",
    ]),

    sortedProjects() {
      switch (this.sortedBy) {
        case "newer":
          return [...this.filteredProjects].sort(this.sortProjectsByDate);
        case "oldest":
          return [...this.filteredProjects]
            .sort(this.sortProjectsByDate)
            .reverse();
        case "a-to-z":
          return [...this.filteredProjects].sort(this.sortProjectsByTitle);
        case "z-to-a":
          return [...this.filteredProjects]
            .sort(this.sortProjectsByTitle)
            .reverse();
        default:
          return [...this.filteredProjects];
      }
    },

    filteredProjectsByReps() {
      return this.showArchivedProjects
        ? [...this.projects]
        : [...this.projects].filter((pr) => {
            switch (pr.project_type) {
              case "showroom":
                return pr.status?.toLowerCase !== "archived";

              case "catalog":
                return (
                  pr.status_name?.toLowerCase() !== "archived" ||
                  pr.status?.toLowerCase() !== "archived" ||
                  !pr.deleted_at
                );

              case "snapsheet":
                return (
                  pr.status?.toLowerCase() !== "archived" || !pr.deleted_at
                );

              default:
                //WTF 👀👀👀
                return true;
            }
          });
    },

    filteredProjects() {
      //Filter by status
      const projectsByFilter = this.filteredProjectsByReps?.filter(
        (project) => {
          if (
            this.statusToFilter?.includes(CONSTANTS.PROJECT_STATUS.ARCHIVED) &&
            project.deleted_at
          ) {
            return true;
          } else {
            return this.statusToFilter?.includes(project?.status);
          }
        }
      );

      //Check if the archived projects filter is active

      if (this.statusToFilter?.includes(CONSTANTS.PROJECT_STATUS.ARCHIVED)) {
        return projectsByFilter;
      } else {
        return projectsByFilter?.filter((pr) => !pr.deleted_at);
      }
    },

    filterByAllReps: {
      get() {
        return this.repsToFilter.length === 0;
      },
      set() {
        if (this.repsToFilter.length) {
          this.repsToFilter = [];
        }
      },
    },

    fsgSiteCreateProjectUrl() {
      return this.typesOfProjectsToShow === "snapsheet"
        ? this.fsgSiteCreateSnapsheetUrl
        : this.fsgSiteCreatePlaybookUrl;
    },
  },

  watch: {
    $route(to) {
      //React to the projects_type param in the url
      if (to.params.projects_type) {
        this.typesOfProjectsToShow = to.params.projects_type;
      } else {
        this.typesOfProjectsToShow = "";
      }
    },

    async typesOfProjectsToShow() {
      this.page = 1;
      this.$store.commit("setActivePage", `My ${this.typesOfProjectsToShow}s`);
      await this.getProjects(true);
    },

    page() {
      this.getProjects();
    },

    sortedBy() {
      this.getProjects(true);
    },

    statusToFilter() {
      this.getProjects(true);
    },

    async filterByAllReps(value) {
      if (value)
        try {
          await this.getProjects(true);
        } catch (error) {
          console.log(error);
        }
    },
  },

  methods: {
    ...mapActions(["setLoading"]),
    dateFormatted(created_at) {
      const currentDate = new Date(created_at);
      const day = currentDate.getDate();
      const month = currentDate.getMonth() + 1;
      const year = currentDate.getFullYear();
      return `${month}/${day}/${year}`;
    },

    setPage(page) {
      this.page = page;
    },

    setSortedBy(optSelected) {
      this.sortedBy = optSelected;
    },

    toggleShowArchiveProjects() {
      this.showArchivedProjects = !this.showArchivedProjects;
    },

    triggerSearch() {
      this.getProjects(true); //todo improve
    },

    async getProjects(reset = false) {
      this.loading = true;
      if (reset) this.setPage(1);
      let params = {
        page: this.page,
        project_type: `${this.typesOfProjectsToShow}s`,
        sort_by: this.sortedBy,
        per_page: 10,
      };

      //Reps Filter
      if (this.repsToFilter.length > 0) params["reps_ids"] = this.repsToFilter;
      if (this.statusToFilter.length > 0)
        params["status_filter"] = this.statusToFilter;

      if (this.filters.search.trim().length)
        params["title"] = this.filters.search.trim();

      await axios
        .get(this.settings.endpoint + "api/v2/projects", {
          params,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.auth.apiToken,
          },
        })
        .then((response) => {
          response.data.data
            ? (this.projects = Object.entries(response.data.data).map(
                (project) => {
                  return project[1];
                }
              ))
            : [];
          this.totalPages = response.data.last_page;
          this.totalItems = response.data.total;
          // this.loading = false;
        })
        .catch((error) => {
          this.$store.dispatch("showToast", {
            txt: error,
            type: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getCustomers: debounce(async function (reset = false) {
      // this.loading = true;
      if (reset) this.setPage(1);

      let params = {
        page: this.page,
        sort_by: this.sortedBy,
        api_token: this.auth.apiToken,
      };

      if (parseInt(this.filters.rep_id)) params["rep_id"] = this.filters.rep_id;

      if (this.filters.search.trim().length)
        params["search_query"] = this.filters.search.trim();

      await axios
        .get(this.settings.endpoint + "api/customers", {
          params,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.auth.apiToken,
          },
        })
        .then((response) => {
          response.data ? (this.customers = response.data.data) : [];
          // this.loading = false;
        })
        .catch((error) => {
          this.$store.dispatch("showToast", {
            txt: error,
            type: "error",
          });
        })
        .finally(() => {
          // this.loading = false;
        });
    }, 500),

    updateProjectData(updatedProject) {
      const projecstUpdated = this.projects.map((pr) => {
        if (
          updatedProject.id === pr.id &&
          updatedProject.project_type === pr.project_type
        ) {
          pr = { ...pr, ...updatedProject };
        }
        return pr;
      });

      this.projects = projecstUpdated;
    },

    sortProjectsByDate(a, b) {
      return new Date(b.created_at) - new Date(a.created_at);
    },

    sortProjectsByTitle(a, b) {
      return a.title.localeCompare(b.title);
    },

    openEditModal({ project, type }) {
      this.editMode = true;
      this.projectToBeEdited = project;
      this.projectTypeToBeEdited = type;
    },

    closeAllMenus() {
      this.showRepsFilter = false;
      this.showStatusFilter = false;
      this.openedMenu = null;
    },

    editEvent() {
      this.editMode = false;
    },

    async handleRepFilter(rep) {
      //Find the rep in the array
      const index = this.repsToFilter.findIndex(
        (repId) => Number(repId) === Number(rep.id)
      );
      if (index === -1) {
        this.repsToFilter.push(rep.id);
      } else {
        this.repsToFilter = this.repsToFilter.filter(
          (id) => Number(id) !== Number(rep.id)
        );
      }
      try {
        await this.getProjects(true);
      } catch (error) {
        console.log(error);
      }
    },

    async handleStatusFilter(status) {
      //Find the rep in the array
      const index = this.statusToFilter.findIndex(
        (statusInFilter) => statusInFilter === status
      );

      if (index === -1) {
        this.statusToFilter.push(status);
      } else {
        this.statusToFilter = this.statusToFilter.filter(
          (statusInFilter) => statusInFilter !== status
        );
      }
    },

    handleSetOpenedMenu(id) {
      this.showRepsFilter = false;
      this.openedMenu = id;
    },
  },

  async mounted() {
    this.typesOfProjectsToShow = this.$route.params.projects_type;
    this.$store.commit("setActivePage", `My ${this.typesOfProjectsToShow}s`);

    //Initialize filter by status, unchecking the archived option
    this.statusToFilter = Object.values(CONSTANTS.PROJECT_STATUS);
    const archivedStatusIndex = this.statusToFilter.indexOf(
      CONSTANTS.PROJECT_STATUS.ARCHIVED
    );
    if (archivedStatusIndex > -1) {
      // only splice array when item is found
      this.statusToFilter.splice(archivedStatusIndex, 1); // 2nd parameter means remove one item only
    }

    try {
      this.loading = true;
      await this.getProjects();
    } catch (error) {
      this.loading = false;
      this.$store.dispatch("showToast", {
        txt: error,
        type: "error",
      });
    } finally {
      this.loading = false;
    }
  },
};
</script>
<style lang="scss" scoped>
.header-container {
  margin-bottom: 1.75rem;
  h1 {
    font-size: 1.75rem;
    margin-right: 2rem;
  }

  .btn {
    border: 1px solid $grey-dark !important;
    color: $grey-dark !important;
    text-transform: capitalize;
    margin-left: auto;
    border-radius: 6px;
    padding: 0.5rem !important;
    &:hover {
      background-color: $grey-dark !important;
      color: white !important;
    }
    img {
      margin-right: 0.25rem;
    }
    a {
      color: $grey-dark !important;
      padding: 0.25rem;
    }
  }

  .input-container {
    input {
      border: 1px solid $placeholder !important;
      ::placeholder {
        color: $placeholder !important;
      }
      /* color: $placeholder !important; */
    }
  }

  #search-by-name-container {
    img {
      transition: all 0.2s;
    }
    &:hover {
      img {
        filter: invert(1);
      }
    }
  }
}

::v-deep .projects-container {
  ul {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    width: 100%;

    li {
      &.title {
        width: 30%;
        text-transform: capitalize;
        a {
          color: $dark;
          &:hover {
            color: $blue;
            text-decoration: underline !important;
          }
        }
      }
      &.date {
        width: 20%;
      }
      &.rep {
        width: 20%;
      }
      &.status {
        width: 20%;
        text-transform: capitalize;
      }
    }
  }

  .table-header {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
    padding: 0 0.75rem;
    li {
      color: $grey-dark;
    }
  }

  .table-column {
    display: flex;
    align-items: center;
    /* width: 25%; */

    &.rep {
      position: relative;

      .filter-container {
        justify-content: center;
        background: white;
        border-radius: 6px;
        box-shadow: 0px 9px 18px rgba(40, 42, 48, 0.2);
        display: flex;
        flex-direction: column;
        padding: 1rem;
        position: absolute;
        top: 3rem;
        left: -25%;
        width: 100%;
        z-index: 10;
        opacity: 0;
        transition: all 0.1s ease-in-out;
        visibility: hidden;
        &.active {
          opacity: 1;
          visibility: visible;
        }
        label {
          display: flex;
          align-items: center;
          margin-bottom: 0.5rem;
          text-transform: capitalize;
          input {
            margin-right: 0.75rem;
          }
        }
      }
    }
  }

  .table-content-container {
    li.table-item {
      width: 100%;
      padding: 0.5rem 0.75rem;
      background: white;
      border-bottom: 1px solid $dark;
      li.table-column {
        img {
          margin-right: 0.5rem;
        }
      }
    }
  }
}

label {
  margin-bottom: 0;
}
select,
option {
  text-transform: capitalize;
}

.mb-mobile-4 {
  @media screen and (max-width: 1024px) {
    margin-bottom: 1.2rem;
  }
}
</style>
